import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApihelperFunction } from "../../API/ApiHelperFunction";

const initialState = {
    status: '',
    data: '',
    error: false,
    loading: false,
    message: ''
}

export const AddTradingPartner = createAsyncThunk("/AddTradingPartner", async (addFundTransactionReqData) => {
    let data = new FormData();
    for (const key in addFundTransactionReqData) {
        if (addFundTransactionReqData.hasOwnProperty(key)) {
                data.append(key, addFundTransactionReqData[key]);
        }
    }
    const response = await ApihelperFunction({
        urlPath: "api/addTradingPartner",
        formData: data,
        method: "post",
        typecontent: true
    });
    return response;
});

const AddTradingPartnerSlice = createSlice({
    name: "AddTradingPartner",
    initialState,
    reducers: {
        resetStateAddTradingPartner: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(AddTradingPartner.pending, (state) => {
                state.status = 'LOADING'
                state.loading = true
                state.error = false
                state.message = ''
            })
            .addCase(AddTradingPartner.fulfilled, (state, action) => {
                if (action?.payload?.status) {
                    state.loading = false
                    state.error = false
                    state.status = "SUCCESS"
                    state.message = action?.payload?.message
                    localStorage.removeItem('createTradingPartnerStepOne')
                    localStorage.removeItem('createTradingPartnerStepTwo')
                }
                else {
                    state.loading = false
                    state.status = "ERROR"
                    state.error = [action?.payload?.errors]
                }
                state.data = action?.payload?.data;
            })
            .addCase(AddTradingPartner.rejected, (state, action) => {
                state.loading = false
                state.status = 'ERROR'
            })
    }
})

export const { resetStateAddTradingPartner } = AddTradingPartnerSlice.actions;
export default AddTradingPartnerSlice.reducer